import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import serialize from 'form-serialize';
import Swiper from 'swiper/js/swiper';
import axios from 'axios';

import { SERIALIZE_SETTINGS } from '../utils/default-settings';
import { onlyIntegerNoLeadingZero } from '../utils/numbers';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $slider: this.el._$('.swiper-container')
    };
    this.pristineSettings = {
      classTo: 'field-wrapper',
      errorClass: 'field-wrapper--error',
      successClass: null,
      errorTextParent: null,
      errorTextTag: null,
      errorTextClass: null
    };
    this.showMessageClass = 'product-listing__message--show';
    this.showMessageCenterClass = 'product-listing__message--show-center';

    this.init();
  }

  addListeners() {
    if (this.dom.$slider) {
      this.swiper.on(
        'slideChangeTransitionEnd breakpoint',
        this.bindMethods.bind(this)
      );
      this.swiper.on('breakpoint', this.updateNavDisplay.bind(this));
      document.addEventListener(constEvent.CART_MODAL_SHOWN, () => {
        if (this.swiper) this.swiper.destroy();
        this.init();
      });
    }
  }

  init() {
    const breakpoints = {
      600: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 34
      }
    };

    if (this.dom.$slider) {
      if (this.dom.$slider.closest('.modal-cart')) {
        breakpoints[600] = {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 34
        };
      }

      this.swiper = new Swiper(this.dom.$slider, {
        loop: true,
        autoHeight: false,
        simulateTouch: false,
        loopFillGroupWithBlank: true,
        breakpoints,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: false
        },

        navigation: {
          nextEl: '.swiper-arrow--next',
          prevEl: '.swiper-arrow--prev'
        }
      });

      this.updateNavDisplay();
    }
    this.bindMethods();
  }

  updateNavDisplay() {
    const $page = this.dom.$slider._$('.swiper-pagination-total');
    const totalPages = parseInt($page.textContent, 10);

    if (totalPages === 1) {
      this.dom.$slider.classList.add('pagination-disabled');
    } else {
      this.dom.$slider.classList.remove('pagination-disabled');
    }
  }

  bindMethods() {
    const $slides = this.el._$$('.swiper-slide');

    $slides.forEach($slide => {
      if ($slide.classList.contains('initialized')) return;

      $slide.classList.add('initialized');

      const dom = {
        $form: $slide._$('form'),
        $quantity: $slide._$('.field__input'),
        $btnAddToCart: $slide._$('button[type="submit"]'),
        $btnAddToList: $slide._$('.btn--flat'),
        $message: $slide._$('.product-listing__message')
      };

      dom.$btnAddToList?._on('click', e => this.addToList(e, dom, pristine));

      if (!dom.$form) return;
      const pristine = new Pristine(dom.$form, this.pristineSettings);
      dom.$btnAddToCart?._on('click', e => this.addToCart(e, dom, pristine));
      dom.$quantity?._on?.('input', e =>
        this.validateQuantity(e, dom, pristine)
      );
    });
  }

  addToCart(e, dom, pristine) {
    e.preventDefault();
    const { $form, $message, $btnAddToCart } = dom;
    const valid = pristine.validate();
    const endpoint = $form.getAttribute('action');

    if (valid) {
      const formData = serialize($form, SERIALIZE_SETTINGS);
      this.hideMessage(dom);
      $btnAddToCart.disabled = true;

      this.post(endpoint, formData)
        .then(response => {
          const { success, body, message } = response?.data;

          if (success) {
            // dispatch custom event for GA4 add_to_cart on addtional required products
            const event = new CustomEvent('requiredAddedToCart', { detail: body });
            document.dispatchEvent(event);

            this.updateProductStatusToAddedToCart($form);
            dispatchGenericEvent(
              constEvent.UPDATE_CART_INDICATOR,
              body?.cart?.allItems?.count || null
            );
          } else {
            $message.textContent = message;
            $message.classList.add(this.showMessageCenterClass);
          }
        })
        .finally(() => {
          $btnAddToCart.disabled = false;
        });
    } else {
      this.showQuantityErrorMessage(dom, pristine);
    }
  }

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  }

  addToList(e, dom) {
    e.preventDefault();
    const { $btnAddToList } = dom;

    const productId = $btnAddToList?.getAttribute('data-product-id') || null;
    dispatchGenericEvent(constEvent.SHOW_ADD_TO_LIST_MODAL, productId);
  }

  validateQuantity(e, dom, pristine) {
    const value = e.target.value;
    e.target.value = onlyIntegerNoLeadingZero(value);

    this.showQuantityErrorMessage(dom, pristine);
  }

  showQuantityErrorMessage(dom, pristine) {
    const { $message } = dom;
    const errors = pristine.getErrors();

    if (errors.length) {
      const errorMessage =
        errors[0]?.input?.dataset?.pristineRequiredMessage || null;

      if (errorMessage) {
        $message.textContent = errorMessage;
        $message.classList.add(this.showMessageClass);
      }
    } else {
      this.hideMessage(dom);
    }

    if (this.dom.$slider) {
      this.swiper.updateAutoHeight();
    }
  }

  hideMessage(dom) {
    const { $message } = dom;

    $message.classList.remove(this.showMessageClass);
    $message.classList.remove(this.showMessageCenterClass);
  }

  updateProductStatusToAddedToCart($form) {
    const label = this.el.dataset?.labelAddedToCart || 'Added to cart';
    $form._$('.product-listing__atc-wrapper').innerHTML = `
      <button type="button" class="btn btn--tertiary btn--full-width">
        <span>${label}</span>
      </button>
    `;
  }
}

export default Module;
